import React from "react";
import "./Products.css";
import Pump1530 from "../../assets/services-1.jpg";
import Pump1575 from "../../assets/services-2.jpg";
import Pump1515 from "../../assets/services-3.jpg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import finalBanner from "../../assets/finalbanner.png";
import { FaShieldAlt } from "react-icons/fa";


const TransformerOilPumps = () => {
  const models = [
    { id: "1530", name: "Model 1530", img: Pump1530 },
    { id: "1575", name: "Model 1575", img: Pump1575 },
    { id: "1515", name: "Model 1515", img: Pump1515 }
  ];

  return (
    <div className="cyber-root">
      <div className="blueprint-bg" />

      {/* ================= HERO BANNER ================= */}
   <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
    GLANDLESS TRANSFORMER OIL PUMPS
</motion.h1>

  </div>
</section>

      {/* ================= CONTENT ================= */}
      <div className="dashboard-container">
        {/* SIDEBAR */}
        <aside className="sidebar-nav">
          <h3>Product Categories</h3>

          <nav className="nav-buttons">
            <Link className="active" to="/products/transformer-oil-pumps">
              Glandless Transformer Oil Pumps
            </Link>
            <Link to="/products/monoblock-pumps">
              Self-Priming Monoblock Pumps
            </Link>
            <Link to="/products/canned-motor-pumps">
              Sealless Canned Motor Pumps
            </Link>
            <Link to="/products/marine-pumps">
              Marine Centrifugal Pumps
            </Link>
            <Link to="/products/process-pumps">
              Centrifugal Process Pump
            </Link>
          </nav>

          <button className="side-btn">Technical Catalog</button>
        </aside>

        {/* MAIN */}
    
        <main className="industrial-panel">
              <div className="panel-top">
                    <FaShieldAlt className="cyan-icon" />
                    <h2>Glandless Transformer Oil Pumps</h2>
                  </div>
                  <br/>
          <p className="company-description">
          FLOWTECH PUMPS AND MOTORS offers Centrifugal, Axial flow & Centrifugal Inline design suitable to meet distribution, power, generating transformers and EMU, Locomotive transformers. These are monobloc in construction and glandless in design. Operating with an induction motor and frictionless bearing and submerged in the pumping liquid. These are meeting the Indian Standard & International Standard requirements and the prime movers are as per IEC 34-1 Range: 0.3K to 10K LPM.
          </p>

          <div className="product-grid">
            {models.map((m) => (
              <div key={m.id} className="pump-card">
                <div className="img-holder">
                  <span className="pump-id">{m.id}</span>
                  <img src={m.img} alt={m.name} />
                </div>
                <Link to="/products/transformer-oil-pumps" onClick={() => window.scrollTo(0, 0)}> 
  <button className="view-btn">View Datasheet</button>
</Link>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default TransformerOilPumps;
